export const ACCESS_STATUS = Object.freeze({
  ACTIVE: 'active',
  EXPIRED: 'expired',
  DISABLED: 'disabled',
});

// Mesmos rótulos do BO (modal de acessos do pedido)
export const ACCESS_STATUS_LABELS = Object.freeze({
  [ACCESS_STATUS.ACTIVE]: 'Ativo',
  [ACCESS_STATUS.EXPIRED]: 'Expirado',
  [ACCESS_STATUS.DISABLED]: 'Desabilitado',
});

export class OrderAccess {
  constructor(access = {}) {
    this.id = access.id ?? '';
    this.productId = access.productId ?? '';
    this.productName = access.productName ?? '';
    this.itemId = access.itemId ?? '';
    this.itemName = access.itemName ?? '';
    this.horizontal = access.horizontal ?? '';
    this.isActive = access.isActive ?? false;
    this.status = access.status ?? (this.isActive ? ACCESS_STATUS.ACTIVE : ACCESS_STATUS.EXPIRED);
    this.startsAt = access.startsAt ?? null;
    this.expiresAt = access.expiresAt ?? null;
    this.accumulatedExpiresAt = access.accumulatedExpiresAt ?? null;
    this.untilExamDate = access.untilExamDate ?? false;
  }

  get effectiveExpiresAt() {
    return this.accumulatedExpiresAt ?? this.expiresAt;
  }

  get statusLabel() {
    return ACCESS_STATUS_LABELS[this.status] ?? ACCESS_STATUS_LABELS[ACCESS_STATUS.EXPIRED];
  }

  static fromJson(json) {
    return new OrderAccess({
      id: json.id ?? '',
      productId: json.product_id ?? '',
      productName: json.product_name ?? '',
      itemId: json.item_id ?? '',
      itemName: json.item_name ?? '',
      horizontal: json.horizontal ?? '',
      isActive: json.is_active ?? false,
      status: json.status ?? null,
      startsAt: json.starts_at ?? null,
      expiresAt: json.expires_at ?? null,
      accumulatedExpiresAt: json.accumulated_expires_at ?? null,
      untilExamDate: json.until_exam_date ?? false,
    });
  }
}
